module.exports = __webpack_public_path__ + "img/logo.2102f3f8.svg";